import { Alert, Button, notification, Table } from "antd";
import Column from "antd/es/table/Column";
import { FetchWithAuth } from "digimaker-ui/util";
import { useEffect, useState } from "react";
import Moment from "react-moment";

export const GuideTransactions = (props: { id: number }) => {
  const [commisions, setCommisions] = useState([]);

  const [payments, setPayments] = useState([]);

  useEffect(() => {
    FetchWithAuth("/api/ns/guide/list_groups?id=" + props.id).then((res) => {
      if (res.error) { notification.error({ message: res.data.message }); return; }
      setCommisions(res.data);
    });
    FetchWithAuth("/api/ns/guide/payments?id=" + props.id).then((res) => {
      if (res.error) { notification.error({ message: res.data.message }); return; }
      setPayments(res.data);
    });
  }, []);

  const commissionSum = () => {
    let result = 0;
    for (const item of commisions) {
      result += item.comission;
    }
    return result;
  };

  const paymentSum = () => {
    let result = 0;
    for (const item of payments) {
      result += item.amount;
    }
    return result;
  };

  return (
    <div>
      <div>
        <Alert
          type="info"
          message={
            <div>
              共有佣金: {commissionSum()}, 结算: {paymentSum()}, 剩余:
              {commissionSum() - paymentSum()}
            </div>
          }
        ></Alert>
      </div>
      <br />
      <h3>佣金</h3>
      <Table dataSource={commisions}>
        <Column title="团号" dataIndex="name" key="name" />
        <Column title="佣金(NOK)" dataIndex="comission" key="comission" />
      </Table>

      <h3>已结算</h3>
      <div>
        <Button>添加结算</Button>{" "}
      </div>
      <Table dataSource={payments}>
        <Column
          title="日期"
          render={(item) => <Moment format="YYYY-MM-DD">{item.date}</Moment>}
        />
        <Column title="已结算金额" dataIndex="amount" key="amount" />
        <Column title="人员" dataIndex="user" key="user" />
      </Table>
    </div>
  );
};
